/* BIA product page behaviour. Everything degrades without JS. */
(function () {
  'use strict';

  function init(root) {
    var scope = root || document;

    /* --- mobile gallery counter --- */
    scope.querySelectorAll('[data-bp-gal]').forEach(function (gal) {
      var out = gal.parentNode.querySelector('[data-bp-count]');
      if (!out) return;
      var figs = gal.querySelectorAll('.bp__fig');
      var total = figs.length;
      if (!total) return;
      var tick = false;
      function update() {
        tick = false;
        var i = Math.round(gal.scrollLeft / Math.max(gal.clientWidth, 1)) + 1;
        if (i < 1) i = 1;
        if (i > total) i = total;
        out.textContent = i + ' / ' + total;
      }
      out.textContent = '1 / ' + total;
      gal.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(update);
      }, { passive: true });
    });

    /* --- size guide drawer --- */
    scope.querySelectorAll('[data-bp-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.getAttribute('data-bp-guide-open'));
        if (d && typeof d.showModal === 'function') { d.showModal(); }
        else if (d) { d.setAttribute('open', ''); }
      });
    });
    scope.querySelectorAll('[data-bp-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = btn.closest('dialog');
        if (d && typeof d.close === 'function') { d.close(); }
        else if (d) { d.removeAttribute('open'); }
      });
    });

    /* --- image zoom (desktop only) --- */
    var zoom = scope.querySelector('[data-bp-zoom]');
    if (zoom && window.matchMedia('(min-width:1000px)').matches) {
      var zimg = zoom.querySelector('img');
      scope.querySelectorAll('[data-bp-zoomsrc]').forEach(function (fig) {
        fig.addEventListener('click', function () {
          if (!zimg || typeof zoom.showModal !== 'function') return;
          zimg.src = fig.getAttribute('data-bp-zoomsrc');
          zimg.alt = fig.getAttribute('data-bp-zoomalt') || '';
          zoom.showModal();
        });
      });
    }

    /* --- size selection reflected in the sticky bar, no cart involvement --- */
    scope.querySelectorAll('[data-bp-size]').forEach(function (input) {
      input.addEventListener('change', function () {
        scope.querySelectorAll('[data-bp-sizeout]').forEach(function (o) {
          o.textContent = input.value;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
